/**
 * @file Vivaldi client.
 */
import * as imgix from './imgix'
import * as inhouseService from './inhouse_service'
import { getTransformOptions } from './options_parser'
import { RequestOptions, TransformOptions } from './types'
import { buildProxyUrl } from './url_builder'
import { cleanUrlForInhouse, isValidImageDataUrl } from './url_parser'
import * as wagner from './wagner'

const processedUrl = (url: string, options: RequestOptions = {}): string => {
  if (!url) {
    console.info(`[vivaldi-client] url is blank`)
  }

  // if url is blank or url is relative, just return it. There isn't much we can do.
  if (!url || url.startsWith('/')) return url

  // Return valid image data URLs as-is. If it's arbitrary data, return an empty string instead.
  if (url.startsWith('data:')) {
    return isValidImageDataUrl(url) ? url : ''
  }

  // Setting options
  const transformOptions: TransformOptions = getTransformOptions(options)

  // We have to use unsplash's own image api per policy.
  if (imgix.canServe(url, options)) {
    return imgix.processedUrl(url, transformOptions)
    // TODO: Uncomment this once we have tested cloudflare transform a bit more
    // } else if (cloudflare.canServe(url, transformOptions)) {
    //   return cloudflare.processedUrl(url, transformOptions)
  } else if (wagner.canServe(url, transformOptions)) {
    return wagner.processedUrl(url, transformOptions)
  } else {
    const cleanUrl = cleanUrlForInhouse(url)
    return inhouseService.processedUrl(cleanUrl, transformOptions)
  }
}

const proxiedUrl = buildProxyUrl

export { processedUrl, proxiedUrl }
